import TNTControlBase from '../../util/TNTControlBase';

class SetupController extends TNTControlBase {
  /*@ngInject*/
  constructor($state) {
    super();
    this.$state = $state
    this.id = "setup"
    this._id = 'branch_setup';
    this.acl = {}
    this.hasACL = {}

  }
  $onInit() {
    super.$onInit()
    for (let key in this.acl['tnt_control_' + this._id]) {
      this.hasACL[this.acl['tnt_control_' + this._id][key]] = true;
    }
  }
}

export default SetupController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/setup/setup.controller.js